/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import React from 'react';

import PropTypes from 'prop-types';
import { MIN_VEHICLES, MAX_VEHICLES } from 'ui-permit/shared-components/constants';
import VehiclesDetailHOC from 'ui-permit/shared-components/registration/VehiclesDetail';
import { readRuleValue } from 'ui-permit/src/utils/utilsNew';
import { vehiclesSizeMapping } from 'ui-hunting-permit/src/constants/registration';

const VehiclesDetail = VehiclesDetailHOC(null, null);

const propTypes = {
    permit: PropTypes.object,
    pActions: PropTypes.shape({
        updatePendingReservation: PropTypes.func,
        formValidationChange: PropTypes.func,
    }),
    reservation: PropTypes.object,
    validation: PropTypes.object,
};

export default function VehicleListWrapper(props) {
    return (
        <VehiclesDetail
            {...props}
            minVehicles={
                readRuleValue(MIN_VEHICLES, props.permit.rules) ||
                vehiclesSizeMapping[props.permit?.id]?.min ||
                0
            }
            maxVehicles={
                readRuleValue(MAX_VEHICLES, props.permit.rules) ||
                vehiclesSizeMapping[props.permit?.id]?.max ||
                7
            }
            isDescriptionRequired
            isLicensePlateRequired
            isStateRequired
        />
    );
}

VehicleListWrapper.propTypes = propTypes;
